import useSWR from 'swr';
import { userApi } from 'src/api/userApi';

const fetcher = () => userApi.getAllUsers();

const useUsers = () => {
  const { data, error, isLoading } = useSWR('users', fetcher);

  const users = data || [];

  return {
    users,
    error,
    isLoading,
  };
};

export default useUsers;
